<template>
  <div class="row align-items-center mt-5">
    <div class="col-sm-12 col-md-4" style="height: 44px;">
      <b-dropdown
        :text="'Page Size: ' + rowsPerPage"
        class=""
        size="sm"
        variant="light"
      >
        <b-dropdown-item @click="setPageSize(6)">6</b-dropdown-item>
        <b-dropdown-item @click="setPageSize(10)">10</b-dropdown-item>
        <b-dropdown-item @click="setPageSize(20)">20</b-dropdown-item>
        <b-dropdown-item @click="setPageSize(50)">50</b-dropdown-item>
        <b-dropdown-item @click="setPageSize(100)">100</b-dropdown-item>
      </b-dropdown>
    </div>
    <div
      class="col-sm-12 col-md-4 text-center text-muted"
      style="height: 44px;"
    >
      <b-badge class="mr-1 px-6" pill variant="light">
        <span v-if="totalRows === 0">No records found</span>
        <span v-if="totalRows === 1">{{ totalRows }} record found</span>
        <span v-if="totalRows > 1">{{ totalRows }} records found</span>
      </b-badge>
    </div>
    <div class="col-sm-12 col-md-4">
      <b-pagination
        :per-page="rowsPerPage"
        :total-rows="totalRows"
        align="right"
        v-model="currentPageData"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "Paginator",
  props: {
    totalRows: Number,
    rowsPerPage: Number,
    currentPage: Number
  },
  data() {
    return {
      currentPageData: this.currentPage
    };
  },
  methods: {
    setPageSize(value) {
      this.$emit("update-pagesize", value);
    }
  },
  watch: {
    currentPageData(newValue, oldValue) {
      //console.log('currentPageData:', newValue, oldValue);
      if (newValue != oldValue) {
        this.$emit("update-currentpage", this.currentPageData);
      }
    }
  }
};
</script>
